import React, { useEffect } from "react";
import chooseUsImg from "../assests/revamp/feature-whyus.png";
import choseUsBgImg from "../assests/choseUsBgImg.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import { useLanguage } from "../i18n/LanguageContext";

export default function ChooseUs() {
  const { t, copy } = useLanguage();

  const handleGetInTouch = () => {
    const getInTouchSection = document.getElementById("contact_us");
    if (getInTouchSection) {
      const topOffset = getInTouchSection.offsetTop - 90;
      window.scrollTo({
        top: topOffset,
        behavior: "smooth",
      });
    }
  };

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease",
      delay: 100,
      once: true,
    });
  }, []);

  return (
    <div className="chooseUsMain" id="why__us">
      <div className="chooseUsMainContainer amgWhyChoose">
        <div className="chooseUsMainContainerChild1 amgWhyChooseCopy">
          <h2 className="chooseUsMainContainerChild1Head">
            {t("why.headBefore")}
            <span className="amg-accent">{t("why.headAccent")}</span>
          </h2>

          <p className="chooseUsMainContainerChild1Para amgWhyChooseLead">
            {t("why.lead")}
          </p>

          <ul className="amgWhyPillars" aria-label={t("why.listAria")}>
            {copy.why.pillars.map((pillar) => (
              <li key={pillar.title} className="amgWhyPillar">
                <h3 className="amgWhyPillarTitle">{pillar.title}</h3>
                <p className="amgWhyPillarBody">{pillar.body}</p>
              </li>
            ))}
          </ul>

          <button
            type="button"
            onClick={handleGetInTouch}
            className="chooseUsMainContainerChild1Button"
          >
            {t("why.enquire")}
          </button>
        </div>

        <div className="chooseUsMainContainerChild2 amgWhyChooseMedia">
          <img
            className="zoom-effect"
            src={chooseUsImg}
            alt={t("why.mediaAlt")}
          />
        </div>
      </div>

      <div className="choseUsBgImgContainer">
        <img style={{ width: "100%" }} src={choseUsBgImg} alt="" />
      </div>
    </div>
  );
}
